import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static outlets = ['line-chart', 'apex-table']
  static targets = ['tab']
  static values = { pollInterval: { type: Number, default: 0 }, params: Object, direction: { type: String, default: 'in' } }

  connect () {
    this.connected = true
    this.direction = this.directionValue
    this.chartParams = { ...this.paramsValue }
    this.startPolling()
  }

  disconnect () {
    this.connected = false
    clearTimeout(this.pollTimeout)
  }

  pollIntervalValueChanged () {
    clearTimeout(this.pollTimeout)
    this.startPolling()
  }

  async selectDay ({ target }) {
    await Promise.all([
      this.refreshCharts({ event_day_id: target.value }),
      ...this.apexTableOutlets.map(table => table.refresh({ event_day_id: target.value }))
    ])
  }

  async selectPeriod ({ target }) {
    await this.refreshCharts({ period: target.value })
  }

  selectDirection ({ target }) {
    this.direction = target.value
    this.chartParams.direction = this.direction
    this.applyDirection()
    this.updateTabUrls()
  }

  applyDirection () {
    const keys = this.direction === 'all' ? ['count_in', 'count_out'] : [`count_${this.direction}`]
    this.lineChartOutlets.filter(chart => chart.element.dataset.apexMetric === 'line_counts')
      .forEach(chart => chart.setSeriesVisibility(keys))
  }

  async refreshCharts (params, preserveVisibility = false) {
    Object.assign(this.chartParams, params)
    this.updateTabUrls()
    await Promise.all(this.lineChartOutlets.map(chart => chart.refresh({ detail: { params: this.chartParams, preserveVisibility } })))
    if (!preserveVisibility) this.applyDirection()
  }

  updateTabUrls () {
    this.tabTargets.forEach(tab => {
      const url = new URL(tab.href)
      Object.entries({ ...this.chartParams, direction: this.direction }).forEach(([key, value]) => url.searchParams.set(key, value))
      tab.href = url.toString()
    })
  }

  startPolling () {
    if (!this.connected || !this.pollIntervalValue) return

    this.pollTimeout = setTimeout(async () => {
      try {
        await this.refreshCharts({}, true)
      } finally {
        this.startPolling()
      }
    }, this.pollIntervalValue)
  }
}
